import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import { useTranslate } from 'react-admin'

const format = process.env.REACT_APP_DATEFORMAT ?? 'DD/MM/YYYY'

const useStyles = makeStyles({
  field: {
    fontSize: '12px',
    lineHeight: '18px',
  },
})

export const StatusDetailDescriptionField = ({
  source,
  record,
  basePath,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()
  const entryCount = record.entries !== undefined ? record.entries.length : 0

  let message = ''
  if (source === 'APPROVED') {
    message = translate('resources.invoices.messages.approvedDetailDescription')
  }
  if (source === 'DELAYED') {
    const gracePeriodPlusOneDayDate = moment
      .utc(record.dueDate)
      .add(+record.graceDays + 1, 'days')
      .format(format)
    if (record.currentDelay === 1) {
      message = translate(
        'resources.invoices.messages.delayedDetailDescriptionSingular'
      )
    } else {
      message = translate(
        'resources.invoices.messages.delayedDetailDescriptionPlural'
      )
    }
    message = message
      .replace('<<currentDelay>>', record.currentDelay)
      .replace('<<dueDate>>', gracePeriodPlusOneDayDate)
  }
  if (source === 'LATE' && !entryCount) {
    if (record.currentDelay === 1) {
      message = translate(
        'resources.invoices.messages.lateWithoutPaymentDetailDescriptionSingular'
      )
    } else {
      message = translate(
        'resources.invoices.messages.lateWithoutPaymentDetailDescriptionPlural'
      )
    }
    message = message.replace('<<currentDelay>>', record.currentDelay)
  }
  if (source === 'LATE' && entryCount > 0) {
    message = translate(
      'resources.invoices.messages.lateWithPaymentDetailDescription'
    )
      .replace('<<currentDelay>>', record.currentDelay)
      .replace('<<dueDate>>', moment.utc(record.dueDate).format(format))
  }
  if (source === 'PAID' && record.lateFees > 0) {
    if (record.delayLastPayment === 1) {
      message = translate(
        'resources.invoices.messages.fullDetailDescriptionSingular'
      )
    } else {
      message = translate(
        'resources.invoices.messages.fullDetailDescriptionPlural'
      )
    }
    message = message.replace('<<delayLastPayment>>', record.delayLastPayment)
  }
  if (source === 'REQUESTED' || source === 'PENDING REVIEW') {
    message = translate(
      'resources.invoices.messages.requestedDescription'
    ).replace('<<createdAt>>', moment.utc(record.requestedDate).format(format))
  }
  return (
    <Typography
      paragraph
      {...props}
      className={classes.field}
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    ></Typography>
  )
}
